import * as ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import './index.scss'
import { makeMainRoutes } from './routes'
import { Gtm } from 'helpers'

// GTM
Gtm.init()
// End GTM

const routes = makeMainRoutes()

ReactDOM.render(
    routes,
    document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx